import { can } from '../../../services/user-utils'
import { Permissions, User } from '../../../../types/user-types'
import { Button, ButtonsContainer, FormField, TextArea, Toggle } from '@msaf/core-react'

interface NotesWrapperProps {
  isLoading: boolean
  togglePublicHandler: () => void
  setValue: (value: string) => void
  newNote: any
  addNoteHandler: () => void
  editNoteHandler: () => void
  cancelHandler: () => void
  addNoteFocusHandler: () => void
  isEditing: boolean
  isDirty: boolean
  isInvalid: boolean
  user: User
}

export default function NoteEdit({
  isLoading,
  togglePublicHandler,
  setValue,
  newNote,
  addNoteHandler,
  editNoteHandler,
  cancelHandler,
  addNoteFocusHandler,
  isEditing,
  isDirty,
  isInvalid,
  user,
}: NotesWrapperProps) {
  const isPublicMessage = !newNote.isPublic ? (
    <>
      <strong aria-labelledby='noteVisibilityLabel'>Council only</strong> - The note will not be made public
    </>
  ) : (
    <>
      <strong aria-labelledby='noteVisibilityLabel'>Public</strong> - The note will be made public
    </>
  )

  const isPublicToggle = can(user, Permissions.ADD_PRIVATE_NOTE) ? (
    <Toggle
      id='note-visibility'
      isChecked={newNote.isPublic}
      isSkeleton={isLoading}
      onChange={togglePublicHandler}
      name='noteVisibility'
    >
      {isPublicMessage}
    </Toggle>
  ) : (
    <div>
      <div className='toggle-message'>
        <strong aria-labelledby='noteVisibilityLabel'>Public</strong> - The note will be made public
      </div>
    </div>
  )

  const noteHelpAction = isEditing ? 'Update' : 'Add'

  return (
    <div className='c-note-form'>
      <FormField
        label='Note content'
        htmlFor='wellNote'
        helpText={isDirty ? `Remember to click '${noteHelpAction} note' before saving changes.` : ''}
        isSkeleton={isLoading}
      >
        <TextArea
          isSkeleton={isLoading}
          id='wellNote'
          value={`${newNote.note ?? ''}`}
          onChange={(e) => setValue(e.target.value)}
          isInvalid={isInvalid}
          onFocus={addNoteFocusHandler}
        />
      </FormField>
      {isDirty && (
        <>
          <div className='c-note-form__toggle'>{isPublicToggle}</div>
          <div className='c-note-button-wrapper'>
            <ButtonsContainer containerStyle='left'>
              {isEditing ? (
                <Button buttonStyle='primary' label='Update note' onClick={editNoteHandler} />
              ) : (
                <Button buttonStyle='primary' label='Add note' onClick={addNoteHandler} />
              )}
              <Button buttonStyle='text-action' label='Cancel' onClick={cancelHandler} />
            </ButtonsContainer>
          </div>
        </>
      )}
    </div>
  )
}
